import React, { Component } from 'react';
import { RulesStepperUtil, StepperComponent } from '.'
import withAppShell from '../../../hoc/withAppShell/WithAppShell';
import { SchoolInformationActions, ErrorLogActions } from '../../../../store'
import { connect } from "react-redux";
import { MuiGrid } from '../../../ui';
import theme from '../../../../assests/theme';
import LogListComponent from '../../school/rules/LogListComponent';
import { ScheduleConstants } from '../schedule/ScheduleConstants';
import { getKeyFromLS, setDataInLS } from '../../../../utils/LocalStorageUtil'
import { StepperUtil } from '.'
import lodashUtil from 'lodash'
import { saveSchoolConcurrently } from '../../../../utils/ConcurrentSchoolSaveUtil';
import { saveSchoolScheduleConstraintsConcurrently } from '../../../../utils/ConcurrentSchoolSaveUtil';
import { rulesUtil } from '../rules/dialog'
class RulesStepperContainer extends Component {
	constructor(props) {
		super(props)
		let localstate = this.props.location.state;
		if (!localstate) {
			localstate = getKeyFromLS(StepperUtil.STEPPER_STATE_KEY_LS);
		} else {
			//this.setLocationStateInLS(localstate);
			setDataInLS(StepperUtil.STEPPER_STATE_KEY_LS, localstate);
		}
		this.state = {
			localstate: localstate,
			scheduleIndex: (localstate && localstate.scheduleIndex) || 0,
			displayError: false,
			//errorItemIndex:null,
			disableEdit: false

		};
		this.viewErrors = this.viewErrors.bind(this);
		this.selectErrorItem = this.selectErrorItem.bind(this);
	}


	componentWillMount() {
		if (this.state.localstate) {
			this.setActiveDetails(this.state.localstate);
		}

		let i18n;
		if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
			i18n = getKeyFromLS("i18n");
		} else {
			i18n = this.props.i18n
		}
		this.setState({
			i18n: i18n,
		})
	}

	componentWillUnmount() {
		//removeDataInLS(LOCAL_STORAGE_DATA_KEY);
	}
	viewErrors(flag) {
		if (this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].errorLog.errors.length > 0) {
			this.setState({ displayError: !flag })
		}
	}
	setActiveDetails = async (data) => {
		await this.props.setActiveSchool(data.activeSchool);

		await this.props.setActiveSchedule({ index: data.scheduleIndex, id: data.activeScheduleId });
		await this.props.setActiveErrorItem({}, null);

		if (data.overrideData) {
			this.props.activeSchool.schedule_constraints[this.state.scheduleIndex] = rulesUtil.deleteDirtyObjectsFromRules(this.props.activeSchool.schedule_constraints[this.state.scheduleIndex])
			this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].timeTableDetails = null
			this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].school_master = {}
			this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].lastPreCheckedDate = null
			this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].errorLog = {
				errors: [],
				warnings: [],
				informations: [],
				errorsCount: 0,
				warningsCount: 0
			}
			this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].status = ScheduleConstants.INPROGRESS
			this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].modifiedDate = new Date()

			//await this.props.editSchoolInformation(this.props.userInformation._id, this.props.activeSchool._id, this.props.activeSchool)

			// 	let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
			// 		this.props.userInformation._id,
			// 		this.props.activeSchool._id, 
			// 		this.props.activeSchool,
			// 		null);
			// }
			let result = await saveSchoolScheduleConstraintsConcurrently(this.props.updateSchoolScheduleConstraints,
				this.props.userInformation._id,
				this.props.activeSchool._id,
				this.props.activeSchool,
				this.state.scheduleIndex,
				null);
		}
		this.setState({ disableEdit: data.disableEdit })
	}
	selectErrorItem = async (index) => {
		let selectedErrorItem = this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].errorLog.errors[index]
		await this.props.setActiveErrorItem(selectedErrorItem, index);
	}

	render() {
		const { i18n } = this.state
		let stepperIndex = (this.state.localstate && this.state.localstate.stepperIndex) || 0;
		let rulesStepperJsonArray = RulesStepperUtil.getRulesStepperJsonArray(i18n)
		if (this.props.activeSchool && Object.keys(this.props.activeSchool).length > 0 && this.props.activeSchool.schedule_constraints && this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].status != ScheduleConstants.COMPLETED) {
			rulesStepperJsonArray.splice(2, 1)
			//condition for rule page
			if (stepperIndex > 1) { stepperIndex = stepperIndex - 1 }
		}
		return (

			this.props.activeSchool && Object.keys(this.props.activeSchool).length > 0 && this.props.activeSchool.schedule_constraints && <MuiGrid container xs={12} style={{ height: '85vh' }} >
				{
					this.props.activeScheduleIndex == this.state.scheduleIndex &&
					<MuiGrid container xs={12} >
						<MuiGrid xs={this.state.displayError ? 10 : 12} >
							<StepperComponent
								{...this.props}
								{...this.state}
								scheduleIndex={this.state.scheduleIndex}
								viewErrors={this.viewErrors}
								activeSchool={this.props.activeSchool}
								title={this.props.activeSchool.schedule_constraint !== undefined ?
									i18n.schedule.createScheduleText :
									this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].name}
								schedule={this.props.activeSchool.schedule_constraints[this.state.scheduleIndex]}
								displayError={this.state.displayError}
								stepperJsonArray={rulesStepperJsonArray}
								stepperIndex={stepperIndex}
								stepperWidth={8}
								disableEdit={this.state.disableEdit}
								errorLog={this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].errorLog}
							/>
						</MuiGrid>
						{this.state.displayError && this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].errorLog.errors.length > 0 &&
							<MuiGrid xs={2} style={{ zIndex: 100, backgroundColor: theme.palette.primary.lightest, marginTop: '75px', position: 'fixed', right: 0 }} align='right'>

								<LogListComponent log={this.props.activeSchool.schedule_constraints[this.state.scheduleIndex].errorLog}
									errorItemIndex={this.props.activeErrorItemIndex} selectErrorItem={this.selectErrorItem} viewErrors={this.viewErrors} displayError={this.state.displayError}{...this.props} />

							</MuiGrid>
						}                    </MuiGrid>

				}
			</MuiGrid>

		)
	}


}

const mapDispatchToProps = (dispatch) => {
	return {
		setActiveSchool: (activeSchool) => dispatch(SchoolInformationActions.setActiveSchool(activeSchool)),
		setActiveSchedule: (data) => dispatch(SchoolInformationActions.setActiveSchedule(data)),
		setActiveErrorItem: (data, index) => dispatch(ErrorLogActions.setActiveErrorItem(data, index)),
		editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data)),
		updateSchoolScheduleConstraints: (ownerId, schoolId, school, scheduleConstraintsIndex) => dispatch(SchoolInformationActions.updateSchoolScheduleConstraints(ownerId, schoolId, school, scheduleConstraintsIndex))
	}
}
const mapStateToProps = (state) => {
	return {
		activeSchool: state.schoolInformation.activeSchool,
		activeScheduleIndex: state.schoolInformation.activeScheduleIndex,
		activeScheduleId: state.schoolInformation.activeScheduleId,
		updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress,
		activeErrorItem: state.errorLog.activeErrorItem,
		activeErrorItemIndex: state.errorLog.activeErrorItemIndex,
		verifyTimeTableInProgress: state.schoolInformation.verifyTimeTableInProgress,
		generateTimeTableInProgress: state.schoolInformation.generateTimeTableInProgress,
		user: state.cognito.user,
		userInformation: state.userProfile.userInformation,
		i18n: state.i18nMessages.i18n

	}
}
//export default (withAppShell(RulesStepperContainer))
export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(RulesStepperContainer))
